/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { GraduatoriaAnteprimaEligibilitaDTO } from '../model/graduatoria-anteprima-eligibilita-dto';
// @ts-ignore
import { GraduatoriaAnteprimaEligibilitaForm } from '../model/graduatoria-anteprima-eligibilita-form';
// @ts-ignore
import { GraduatoriaCanaliEsitoDTO } from '../model/graduatoria-canali-esito-dto';
// @ts-ignore
import { GraduatoriaComunicazioneSummaryDTO } from '../model/graduatoria-comunicazione-summary-dto';
// @ts-ignore
import { GraduatoriaCreationForm } from '../model/graduatoria-creation-form';
// @ts-ignore
import { GraduatoriaListItemDTO } from '../model/graduatoria-list-item-dto';
// @ts-ignore
import { GraduatoriaResiduoDTO } from '../model/graduatoria-residuo-dto';
// @ts-ignore
import { GraduatoriaRicalcoloForm } from '../model/graduatoria-ricalcolo-form';
// @ts-ignore
import { GraduatoriaRigaDTO } from '../model/graduatoria-riga-dto';
// @ts-ignore
import { GraduatoriaRigaPubblicazioneDTO } from '../model/graduatoria-riga-pubblicazione-dto';
// @ts-ignore
import { GraduatoriaScorrimentoDTO } from '../model/graduatoria-scorrimento-dto';
// @ts-ignore
import { GraduatoriaScorrimentoForm } from '../model/graduatoria-scorrimento-form';
// @ts-ignore
import { GraduatoriaScorrimentoStatoDTO } from '../model/graduatoria-scorrimento-stato-dto';
// @ts-ignore
import { GraduatoriaSnapshotDTO } from '../model/graduatoria-snapshot-dto';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelGraduatoriaRigaDTO } from '../model/paged-model-graduatoria-riga-dto';
// @ts-ignore
import { PagedModelGraduatoriaScorrimentoDTO } from '../model/paged-model-graduatoria-scorrimento-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GraduatoriaControllerServiceInterface,
    AnnullaGraduatoriaRequestParams,
    AnteprimaEleggibilitaGraduatoriaRequestParams,
    CalcolaGraduatoriaRequestParams,
    ComunicaGraduatoriaEsitoRequestParams,
    ConfermaGraduatoriaRequestParams,
    EseguiGraduatoriaScorrimentoRequestParams,
    ExportGraduatoriaRequestParams,
    ExportGraduatoriaPubblicazioneRequestParams,
    GetGraduatoriaCanaliEsitoRequestParams,
    GetGraduatoriaDettaglioRequestParams,
    GetGraduatoriaRigheRequestParams,
    GetGraduatoriaScorrimentoRequestParams,
    ListGraduatoriaScorrimentiRequestParams,
    ListGraduatorieRequestParams,
    ListGraduatorieResiduiRequestParams,
    RicalcolaGraduatoriaRequestParams
} from './graduatoria-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GraduatoriaControllerService extends BaseService implements GraduatoriaControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Annulla una graduatoria (BOZZA→rimossa; CONFERMATA→ANNULLATA + eventuale revert bando)
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public annullaGraduatoria(requestParameters: AnnullaGraduatoriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public annullaGraduatoria(requestParameters: AnnullaGraduatoriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public annullaGraduatoria(requestParameters: AnnullaGraduatoriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public annullaGraduatoria(requestParameters: AnnullaGraduatoriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling annullaGraduatoria.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling annullaGraduatoria.');
        }
        const version = requestParameters?.version;
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling annullaGraduatoria.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'version',
            <any>version,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Conta quante pratiche la regola di eleggibilità selezionerebbe (non persiste)
     * Valuta l\&#39;albero di eleggibilità sulle pratiche ACCETTATE del bando e ritorna                     &#x60;selezionate&#x60; su &#x60;candidate&#x60;, **senza creare nessuna graduatoria**.  Serve a verificare una regola prima di calcolare: una regola formalmente valida                     che non ammette nessuno (valore atteso scritto male, &#x60;IN&#x60; senza valore) non dà                     altrimenti alcun segnale finché non si guarda la graduatoria vuota.  Il body porta il solo albero &#x60;eligibilita&#x60;, nella stessa forma del calcolo: un                     albero invalido risponde 422 esattamente come al calcolo. &#x60;eligibilita&#x60; assente                     o vuota &#x3D; tutte le pratiche ACCETTATE.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/anteprima-eleggibilita
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public anteprimaEleggibilitaGraduatoria(requestParameters: AnteprimaEleggibilitaGraduatoriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaAnteprimaEligibilitaDTO>;
    public anteprimaEleggibilitaGraduatoria(requestParameters: AnteprimaEleggibilitaGraduatoriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaAnteprimaEligibilitaDTO>>;
    public anteprimaEleggibilitaGraduatoria(requestParameters: AnteprimaEleggibilitaGraduatoriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaAnteprimaEligibilitaDTO>>;
    public anteprimaEleggibilitaGraduatoria(requestParameters: AnteprimaEleggibilitaGraduatoriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling anteprimaEleggibilitaGraduatoria.');
        }
        const graduatoriaAnteprimaEligibilitaForm = requestParameters?.graduatoriaAnteprimaEligibilitaForm;
        if (graduatoriaAnteprimaEligibilitaForm === null || graduatoriaAnteprimaEligibilitaForm === undefined) {
            throw new Error('Required parameter graduatoriaAnteprimaEligibilitaForm was null or undefined when calling anteprimaEleggibilitaGraduatoria.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/anteprima-eleggibilita`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaAnteprimaEligibilitaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: graduatoriaAnteprimaEligibilitaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Calcola una nuova graduatoria BOZZA del bando (ranking + eleggibilità inline)
     * La regola di eleggibilità è un ALBERO di nodi annidati (&#x60;eligibilita&#x60;): un nodo GRUPPO combina i propri &#x60;figli&#x60; con il proprio &#x60;logica_join&#x60;, un nodo PREDICATO è una foglia che confronta un valore e NON porta &#x60;logica_join&#x60;. Più elementi in radice sono ammessi e valutati in left-fold. &#x60;eligibilita&#x60; assente o vuota &#x3D; tutte le pratiche accettate del bando.  Il multi-valore si esprime annidando: &#x60;classe IN {1,2}&#x60; si scrive come un GRUPPO OR con due foglie EQ.  I 3 &#x60;override_*&#x60; sono opzionali e sovrascrivono per QUESTA graduatoria i parametri di allocazione del bando; assenti &#x3D; si applica la config del bando. Lo zero è un valore: &#x60;override_budget_totale: 0&#x60; significa \&quot;zero euro\&quot;, non \&quot;non impostato\&quot;.  &#x60;usa_residuo_di&#x60; (opzionale) e\&#39; l\&#39;id di una graduatoria CONFERMATA dello stesso bando: la nuova graduatoria alloca sul RESIDUO del bando dopo quella (e i suoi antenati) invece che sull\&#39;intero. Un override superiore al residuo risponde 422; uguale e\&#39; ammesso. Vedi &#x60;GET .../graduatorie/residui&#x60; per le opzioni.  BREAKING: sostituisce la forma precedente ad array piatto di predicati.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public calcolaGraduatoria(requestParameters: CalcolaGraduatoriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaSnapshotDTO>;
    public calcolaGraduatoria(requestParameters: CalcolaGraduatoriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaSnapshotDTO>>;
    public calcolaGraduatoria(requestParameters: CalcolaGraduatoriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaSnapshotDTO>>;
    public calcolaGraduatoria(requestParameters: CalcolaGraduatoriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling calcolaGraduatoria.');
        }
        const graduatoriaCreationForm = requestParameters?.graduatoriaCreationForm;
        if (graduatoriaCreationForm === null || graduatoriaCreationForm === undefined) {
            throw new Error('Required parameter graduatoriaCreationForm was null or undefined when calling calcolaGraduatoria.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaSnapshotDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: graduatoriaCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Comunica ai cittadini l\&#39;esito di una graduatoria CONFERMATA (Fase A-bis)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/comunica
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public comunicaGraduatoriaEsito(requestParameters: ComunicaGraduatoriaEsitoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaComunicazioneSummaryDTO>;
    public comunicaGraduatoriaEsito(requestParameters: ComunicaGraduatoriaEsitoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaComunicazioneSummaryDTO>>;
    public comunicaGraduatoriaEsito(requestParameters: ComunicaGraduatoriaEsitoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaComunicazioneSummaryDTO>>;
    public comunicaGraduatoriaEsito(requestParameters: ComunicaGraduatoriaEsitoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling comunicaGraduatoriaEsito.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling comunicaGraduatoriaEsito.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/comunica`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaComunicazioneSummaryDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Conferma una BOZZA (allocazione + CONFERMATA + supersede/overlap-guard + stato bando)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/conferma
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public confermaGraduatoria(requestParameters: ConfermaGraduatoriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaSnapshotDTO>;
    public confermaGraduatoria(requestParameters: ConfermaGraduatoriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaSnapshotDTO>>;
    public confermaGraduatoria(requestParameters: ConfermaGraduatoriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaSnapshotDTO>>;
    public confermaGraduatoria(requestParameters: ConfermaGraduatoriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling confermaGraduatoria.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling confermaGraduatoria.');
        }
        const version = requestParameters?.version;
        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling confermaGraduatoria.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'version',
            <any>version,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/conferma`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaSnapshotDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Esegue lo scorrimento del bando (finanzia gli ammessi con il budget liberato)
     * Richiede il disponibile visto in anteprima: se nel frattempo e\&#39; cambiato risponde 409 e non scrive nulla. 422 se la politica di rilascio e\&#39; NESSUNO, se lo stato del bando non ammette lo scorrimento o se non c\&#39;e\&#39; nulla da scorrere. Dopo lo scorrimento servono \&quot;Comunica esito\&quot; e \&quot;Genera voucher\&quot;.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/scorrimento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public eseguiGraduatoriaScorrimento(requestParameters: EseguiGraduatoriaScorrimentoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaScorrimentoDTO>;
    public eseguiGraduatoriaScorrimento(requestParameters: EseguiGraduatoriaScorrimentoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaScorrimentoDTO>>;
    public eseguiGraduatoriaScorrimento(requestParameters: EseguiGraduatoriaScorrimentoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaScorrimentoDTO>>;
    public eseguiGraduatoriaScorrimento(requestParameters: EseguiGraduatoriaScorrimentoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling eseguiGraduatoriaScorrimento.');
        }
        const graduatoriaScorrimentoForm = requestParameters?.graduatoriaScorrimentoForm;
        if (graduatoriaScorrimentoForm === null || graduatoriaScorrimentoForm === undefined) {
            throw new Error('Required parameter graduatoriaScorrimentoForm was null or undefined when calling eseguiGraduatoriaScorrimento.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/scorrimento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaScorrimentoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: graduatoriaScorrimentoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export della graduatoria come righe JSON (il FE genera l\&#39;.xlsx client-side)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/export
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public exportGraduatoria(requestParameters: ExportGraduatoriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GraduatoriaRigaDTO>>;
    public exportGraduatoria(requestParameters: ExportGraduatoriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GraduatoriaRigaDTO>>>;
    public exportGraduatoria(requestParameters: ExportGraduatoriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GraduatoriaRigaDTO>>>;
    public exportGraduatoria(requestParameters: ExportGraduatoriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling exportGraduatoria.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling exportGraduatoria.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/export`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<GraduatoriaRigaDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export «da pubblicare»: la catena in cascata fino a questa graduatoria, numerazione continua, senza dati personali (il FE genera l\&#39;.xlsx client-side)
     * Parte dalla radice della catena e scende alle figlie CONFERMATE; ammessa anche su una graduatoria in BOZZA (catena confermata che la precede + la bozza). Colonne: posizione (continua), sezione (nome della graduatoria), codice_pratica, punteggio, esito. Nessun codice fiscale, nome, ISEE o componenti.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/export-pubblicazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public exportGraduatoriaPubblicazione(requestParameters: ExportGraduatoriaPubblicazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GraduatoriaRigaPubblicazioneDTO>>;
    public exportGraduatoriaPubblicazione(requestParameters: ExportGraduatoriaPubblicazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GraduatoriaRigaPubblicazioneDTO>>>;
    public exportGraduatoriaPubblicazione(requestParameters: ExportGraduatoriaPubblicazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GraduatoriaRigaPubblicazioneDTO>>>;
    public exportGraduatoriaPubblicazione(requestParameters: ExportGraduatoriaPubblicazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling exportGraduatoriaPubblicazione.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling exportGraduatoriaPubblicazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/export-pubblicazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<GraduatoriaRigaPubblicazioneDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Canali su cui partirebbe la comunicazione dell\&#39;esito (solo i nomi, senza testi)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/canali-esito
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getGraduatoriaCanaliEsito(requestParameters: GetGraduatoriaCanaliEsitoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaCanaliEsitoDTO>;
    public getGraduatoriaCanaliEsito(requestParameters: GetGraduatoriaCanaliEsitoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaCanaliEsitoDTO>>;
    public getGraduatoriaCanaliEsito(requestParameters: GetGraduatoriaCanaliEsitoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaCanaliEsitoDTO>>;
    public getGraduatoriaCanaliEsito(requestParameters: GetGraduatoriaCanaliEsitoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getGraduatoriaCanaliEsito.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling getGraduatoriaCanaliEsito.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/canali-esito`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaCanaliEsitoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una graduatoria (metadati + eleggibilità + flag stale)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getGraduatoriaDettaglio(requestParameters: GetGraduatoriaDettaglioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaSnapshotDTO>;
    public getGraduatoriaDettaglio(requestParameters: GetGraduatoriaDettaglioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaSnapshotDTO>>;
    public getGraduatoriaDettaglio(requestParameters: GetGraduatoriaDettaglioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaSnapshotDTO>>;
    public getGraduatoriaDettaglio(requestParameters: GetGraduatoriaDettaglioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getGraduatoriaDettaglio.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling getGraduatoriaDettaglio.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaSnapshotDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Righe paginate di una graduatoria (identità risolta live via pratica_id)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/righe
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getGraduatoriaRighe(requestParameters: GetGraduatoriaRigheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelGraduatoriaRigaDTO>;
    public getGraduatoriaRighe(requestParameters: GetGraduatoriaRigheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelGraduatoriaRigaDTO>>;
    public getGraduatoriaRighe(requestParameters: GetGraduatoriaRigheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelGraduatoriaRigaDTO>>;
    public getGraduatoriaRighe(requestParameters: GetGraduatoriaRigheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getGraduatoriaRighe.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling getGraduatoriaRighe.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling getGraduatoriaRighe.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/righe`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelGraduatoriaRigaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Stato e anteprima dello scorrimento del bando (budget liberato dalle revoche)
     * Lo scorrimento finanzia i primi ammessi non finanziati con il budget liberato dalle revoche dei voucher, prima nella graduatoria padre e poi nelle figlie. E\&#39; a livello di BANDO. &#x60;abilitato&#x60; &#x3D; la politica di rilascio del bando non e\&#39; NESSUNO. &#x60;disponibile_importo&#x60;/&#x60;disponibile_posti&#x60; assenti &#x3D; il bando non ha quel limite: sono i valori da rimandare come \&quot;atteso\&quot; all\&#39;esecuzione. &#x60;piano&#x60; e\&#39; l\&#39;anteprima per graduatoria; nulla viene scritto. &#x60;motivo_non_eseguibile&#x60;: NON_ABILITATO, STATO_BANDO_NON_AMMESSO, NULLA_DA_SCORRERE.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/scorrimento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getGraduatoriaScorrimento(requestParameters: GetGraduatoriaScorrimentoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaScorrimentoStatoDTO>;
    public getGraduatoriaScorrimento(requestParameters: GetGraduatoriaScorrimentoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaScorrimentoStatoDTO>>;
    public getGraduatoriaScorrimento(requestParameters: GetGraduatoriaScorrimentoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaScorrimentoStatoDTO>>;
    public getGraduatoriaScorrimento(requestParameters: GetGraduatoriaScorrimentoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getGraduatoriaScorrimento.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/scorrimento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaScorrimentoStatoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Storico degli scorrimenti eseguiti sul bando
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/scorrimenti
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listGraduatoriaScorrimenti(requestParameters: ListGraduatoriaScorrimentiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelGraduatoriaScorrimentoDTO>;
    public listGraduatoriaScorrimenti(requestParameters: ListGraduatoriaScorrimentiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelGraduatoriaScorrimentoDTO>>;
    public listGraduatoriaScorrimenti(requestParameters: ListGraduatoriaScorrimentiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelGraduatoriaScorrimentoDTO>>;
    public listGraduatoriaScorrimenti(requestParameters: ListGraduatoriaScorrimentiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listGraduatoriaScorrimenti.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listGraduatoriaScorrimenti.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/scorrimenti`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelGraduatoriaScorrimentoDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista delle graduatorie del bando (con flag stale sulle BOZZE)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listGraduatorie(requestParameters: ListGraduatorieRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GraduatoriaListItemDTO>>;
    public listGraduatorie(requestParameters: ListGraduatorieRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GraduatoriaListItemDTO>>>;
    public listGraduatorie(requestParameters: ListGraduatorieRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GraduatoriaListItemDTO>>>;
    public listGraduatorie(requestParameters: ListGraduatorieRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listGraduatorie.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<GraduatoriaListItemDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Residuo del bando dopo ciascuna graduatoria CONFERMATA (opzioni di \&quot;usa il residuo di\&quot;)
     * Per ogni graduatoria CONFERMATA del bando, in ordine di conferma, il budget e i posti che resterebbero a una graduatoria figlia che usasse il suo residuo (limiti del bando meno quanto finanziato dalla catena fino a quella graduatoria). &#x60;residuo_budget&#x60;/&#x60;residuo_posti&#x60; assenti &#x3D; il bando non ha quel limite.  &#x60;disponibile&#x3D;false&#x60; indica che la scelta non e\&#39; ammessa; &#x60;motivo_non_disponibile&#x60; e\&#39; &#x60;FIGLIA_CONFERMATA&#x60; (ha gia\&#39; una figlia confermata: va scelta la foglia della catena) o &#x60;BANDO_SENZA_LIMITI&#x60; (ne\&#39; budget ne\&#39; tetto di beneficiari).
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/residui
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listGraduatorieResidui(requestParameters: ListGraduatorieResiduiRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<GraduatoriaResiduoDTO>>;
    public listGraduatorieResidui(requestParameters: ListGraduatorieResiduiRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<GraduatoriaResiduoDTO>>>;
    public listGraduatorieResidui(requestParameters: ListGraduatorieResiduiRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<GraduatoriaResiduoDTO>>>;
    public listGraduatorieResidui(requestParameters: ListGraduatorieResiduiRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listGraduatorieResidui.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/residui`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<GraduatoriaResiduoDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ricalcola in-place una BOZZA (preserva id/nome; eleggibilità replace)
     * Un campo assente NON tocca nulla: &#x60;eligibilita&#x60; assente preserva la regola precedente (una lista VUOTA invece la azzera → tutte le accettate), e un &#x60;override_*&#x60; assente preserva quello già impostato. Un body vuoto ricalcola senza cambiare la configurazione.  Quando &#x60;eligibilita&#x60; è presente sostituisce l\&#39;ALBERO intero (replace, non modifica per-nodo). Da qui non si azzera un override per tornare alla config del bando: per farlo si annulla la BOZZA e si ricrea.  BREAKING: &#x60;eligibilita&#x60; è la forma ad albero annidato, non più l\&#39;array piatto.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/graduatorie/{idGraduatoria}/ricalcola
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public ricalcolaGraduatoria(requestParameters: RicalcolaGraduatoriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GraduatoriaSnapshotDTO>;
    public ricalcolaGraduatoria(requestParameters: RicalcolaGraduatoriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GraduatoriaSnapshotDTO>>;
    public ricalcolaGraduatoria(requestParameters: RicalcolaGraduatoriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GraduatoriaSnapshotDTO>>;
    public ricalcolaGraduatoria(requestParameters: RicalcolaGraduatoriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling ricalcolaGraduatoria.');
        }
        const idGraduatoria = requestParameters?.idGraduatoria;
        if (idGraduatoria === null || idGraduatoria === undefined) {
            throw new Error('Required parameter idGraduatoria was null or undefined when calling ricalcolaGraduatoria.');
        }
        const graduatoriaRicalcoloForm = requestParameters?.graduatoriaRicalcoloForm;

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/graduatorie/${this.configuration.encodeParam({name: "idGraduatoria", value: idGraduatoria, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/ricalcola`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GraduatoriaSnapshotDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: graduatoriaRicalcoloForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
